<template>
    <div>
        问卷不存在
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {};
    },
    methods: {}
};
</script>

<style scoped lang="scss"></style>
